<template>
  <qx-card title="列表">
    <QrcodeDialog ref="qrcodeDialog" />
    <LogRightDialog ref="logRightDialog" busiCode="400001" />
    <section slot="titleRight">
<!--      <qx-permpisions permpisions="1005020102" v-if="$route.query.serviceType">-->
      <qx-permpisions permpisions="1005020102">
        <el-button type="primary" plain @click="() => toEdit()">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'productName'"
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section
                  v-if="scope.column.property === 'serviceName'"
                  @click="toServiceDetail(scope.row)"
                >
                  <span class="primary cur">
                    {{ scope.row[scope.column.property] }}
                  </span>
                </section>
                <section v-if="scope.column.property === 'price'">
                  <span
                    v-if="
                      scope.row.localeBalanceState !== '' &&
                      scope.row.localeBalanceState !== null &&
                      scope.row.localeBalanceState === 1
                    "
                    >现场价</span
                  >
                  <span
                    v-if="
                      scope.row.isBillAbility !== 1 &&
                      scope.row.floatBalance !== '' &&
                      scope.row.floatBalance !== null
                    "
                    >{{ scope.row.floatBalance }}%</span
                  >
                  <span
                    v-if="
                      scope.row.isBillAbility !== 1 &&
                      scope.row.fixedBalance !== '' &&
                      scope.row.fixedBalance !== null
                    "
                    >{{ scope.row.fixedBalance / 100 }}元/升</span
                  >
                  <span
                    v-if="
                      scope.row.isBillAbility === 1 &&
                      scope.row.floatBalanceBill !== '' &&
                      scope.row.floatBalanceBill !== null
                    "
                    >{{ scope.row.floatBalanceBill }}%</span
                  >
                  <span
                    v-if="
                      scope.row.isBillAbility === 1 &&
                      scope.row.fixedBalanceBill !== '' &&
                      scope.row.fixedBalanceBill !== null
                    "
                    >{{ scope.row.fixedBalanceBill / 100 }}元/升</span
                  >
                </section>
                <section
                  v-if="
                    scope.column.property !== 'productName' &&
                    scope.column.property !== 'serviceName' &&
                    scope.column.property !== 'price'
                  "
                >
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="140"
            fixed="right"
          >
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    permpisions: $route.query.serviceType ? '4000307' : '1005020103',
                    showCondition: scope.row.hasVer === 0,
                    name: '审核',
                    event: () => toDetail(scope.row, 'approve'),
                  },
                  // {
                  //   permpisions: $route.query.serviceType
                  //     ? '4000306'
                  //     : '4000201',
                  //   showCondition: true,
                  //   name: '修改',
                  //   event: () => toEdit(scope.row),
                  // },
                  // {
                  //   permpisions:'1005020104',
                  //   showCondition:
                  //     (scope.row.serviceType === 100 ||
                  //       scope.row.serviceType === 3) &&
                  //     scope.row.authState === 2 &&
                  //     scope.row.tenantId === 1,
                  //   name: '申请',
                  //   event: () => showQrCode(scope.row),
                  // },
                  {
                    // permpisions: $route.query.serviceType
                    //   ? '4000308'
                    //   : '4000202',
                    permpisions:  '4000202',
                    showCondition: scope.row.state === 0,
                    name: '删除',
                    event: () => showQrCode(scope.row),
                  },
                  // {
                  //    permpisions: '1005020101',
                  //   showCondition:
                  //     scope.row.serviceType !== 100 &&
                  //     scope.row.serviceType !== 3,
                  //   name: '交易',
                  //   event: () => toTransRecord(scope.row),
                  // },
                  // {
                  //   showCondition:
                  //     scope.row.authState === 2 &&
                  //     scope.row.state === 1 &&
                  //     (scope.row.serviceType === 1 ||
                  //       scope.row.serviceType === 2),
                  //   name: '二维码',
                  //   event: () => showQrCode(scope.row),
                  // },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.relId),
                  },
                ]"
              />
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  siteList,
} from 'api/service';
import LogRightDialog from 'components/logRightDialog';
import QrcodeDialog from '../qrcodeDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import TableSetting from 'components/tableSetting/tableSetting';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    QrcodeDialog,
    TableBtn,
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'productName', label: '产品名称', fixed: true },
          { prop: 'serviceCall', label: '服务电话' },
          { prop: 'address', label: '服务地址' },
          { prop: 'price', label: '价格', w: '100px' },
          { prop: 'serviceName', label: '归属服务商' },
          { prop: 'stateName', label: '产品状态' },
          { prop: 'authStateName', label: '认证状态' },
          { prop: 'serviceAuthStateName', label: '服务商认证' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: siteList,
    showQrCode (item) {
      this.$refs.qrcodeDialog.show(item);
    },
    showLog (customerId) {
      this.$refs.logRightDialog.show(customerId);
    },
    toEdit (item = {}) {
      let serviceUserId = '';
      if (item.serviceUserId) {
        serviceUserId = item.serviceUserId;
      } else if (this.searchBoxData.serviceUserId) {
        // 跳转过来的
        serviceUserId = this.searchBoxData.serviceUserId;
        item.serviceType = this.$route.query.serviceType;
      }
      this.jump({
        label: (item.productId ? '修改' : '新增') + '后服产品',
        url: `/manage/service/site/self/edit?serviceUserId=${serviceUserId}&serviceType=${item.serviceType || ''}${item.productId ? '&id=' + item.productId : ''}`,
        full: true,
      });
    },
    toDetail (item, type = '') {
      this.jump({
        label: type ? '审核后服产品' : '后服产品详情',
        url: `/manage/service/site/self/detail?serviceUserId=${item.serviceUserId}&serviceType=${item.serviceType}&id=${item.productId}&relId=${item.relId}&type=${type}`,
        full: true,
      });
    },
    toServiceDetail (item) {
      this.jump({
        label: '服务商详情',
        url: `/manage/service/merchant/manage/detail?id=${item.serviceUserId}`,
        full: true,
      });
    },
    toTransRecord (item) {
      this.jump({
        label: '交易记录',
        url: `/manage/service/site/transRecord?productId=${item.productId}&serviceType=${item.serviceType}&productName=${encodeURIComponent(item.productName)}`,
        full: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
